import type { FetchLike } from "@emdur/ui";
import { createContext, useContext } from "react";

/** uploadFile's raw body with its progress (0 to 1), under the caller's Idempotency-Key. */
export type Uploader = (path: string, file: Blob, key: string, onProgress: (fraction: number) => void) => Promise<Response>;

/** How pages reach the Foundation: the signing fetch the kit's helpers take, public reads, uploads, and the API's
 * origin (its public /files/ links). main.tsx provides the real ones; component tests an in-memory Foundation. */
export interface Api {
  fetch: FetchLike;
  publicFetch: FetchLike;
  upload: Uploader;
  apiUrl: string;
}

export const ApiContext = createContext<Api | null>(null);

export function useApi(): Api {
  const api = useContext(ApiContext);
  if (api === null) throw new Error("useApi needs an ApiContext around the page.");
  return api;
}
